export const CELLO_INIT = 'CELLO_INIT';
export const CELLO_INIT_SUCCESS = 'CELLO_INIT_SUCCESS';
export const CELLO_INIT_ERROR = 'CELLO_INIT_ERROR';

export interface ICelloInitAction {
  type: typeof CELLO_INIT;
  payload: {
    productId: string;
    token: string;
    language: string;
    firstName: string;
    lastName: string;
    email: string;
    fullName: string;
    ucc: string;
  };
}

export interface ICelloInitSuccessAction {
  type: typeof CELLO_INIT_SUCCESS;
  payload: {
    productId: string;
    token: string;
    language: string;
    firstName: string;
    lastName: string;
    email: string;
    fullName: string;
    ucc: string;
  };
}
export type CelloActionTypes = ICelloInitAction | ICelloInitSuccessAction;
